export default "__VITE_ASSET__BKDcslqD__"